export const extractConnectionStats = (report) => {
    const candidates = {};
    let nominatedLocal;
    let nominatedRemote;
    report.forEach((rec) => {
        if (rec.type === 'candidate-pair' && rec.nominated) {
            nominatedLocal = rec.localCandidateId;
            nominatedRemote = rec.remoteCandidateId;
        }
        if (rec.type === 'local-candidate' || rec.type === 'remote-candidate') {
            candidates[rec.id] = rec;
        }
    });
    const localCandidate = candidates[nominatedLocal];
    const remoteCandidate = candidates[nominatedRemote];
    if (!localCandidate)
        return;
    return {
        protocol: localCandidate.protocol,
        relay: localCandidate.relayProtocol,
        network: localCandidate.networkType || 'unknown',
        localCandidate: localCandidate.candidateType,
        remoteCandidate: remoteCandidate.candidateType,
    };
};
const findRecInReport = (report, key, val) => {
    let resultRec;
    report.forEach((rec) => (rec[key] === val ? (resultRec = rec) : null));
    return resultRec || {};
};
export const extractMediaStats = (report) => {
    const data = {};
    report.forEach((rec) => {
        if (rec.type === 'inbound-rtp' && rec.kind === 'audio') {
            data.audioCodec = findRecInReport(report, 'id', rec.codecId).mimeType;
            data.audioBytesTransferred = rec.bytesReceived;
            data.audioPacketsTransferred = rec.packetsReceived;
        }
        if (rec.type === 'outbound-rtp' && rec.kind === 'audio') {
            data.audioCodec = findRecInReport(report, 'id', rec.codecId).mimeType;
            data.audioBytesTransferred = rec.bytesSent;
            data.audioPacketsTransferred = rec.packetsSent;
        }
        if (rec.type === 'inbound-rtp' && rec.kind === 'video') {
            data.videoBytesTransferred = rec.bytesReceived;
            data.videoPacketsTransferred = rec.packetsReceived;
            data.videoCodec = findRecInReport(report, 'id', rec.codecId).mimeType;
        }
        if (rec.type === 'outbound-rtp' && rec.kind === 'video') {
            data.videoBytesTransferred = rec.bytesSent;
            data.videoPacketsTransferred = rec.packetsSent;
            data.videoCodec = findRecInReport(report, 'id', rec.codecId).mimeType;
        }
    });
    return data;
};
